export default __webpack_public_path__ + "static/media/achados_e_perdidos.e6b712bd.svg";